
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c80f2a0a!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./disconnectGoogleClassroomModal.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./disconnectGoogleClassroomModal.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c80f2a0a!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./disconnectGoogleClassroomModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/disconnectGoogleClassroomModal.vue
// module id = 156
// module chunks = 61